import { Box, Divider, Grid, Typography } from '@mui/material'
import InputRadio from 'component/Input/InputRadio'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import { useDispatch, useSelector } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */
import { fileUrl } from 'api/api'
import TreatmentHistoryApi from 'api/dentists/treatment-history.api'
import ClinicApi, { DentistInterface } from 'api/master/clinic.api'

/** UTILS || SLICE */
import { closeModal, resetModal } from 'app/slice/modal.slice'
import { treatment, TreatmentStateInterface } from 'app/slice/treatment.slice'
import useWindowSize from "utils/useWindowSize"

/** CONSTANTS */
import { colors } from 'constants/theme'

/** COMPONENT */
import Loading from 'component/Loading'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'

/** STYLE */
import { styled } from '@mui/material/styles'
import { selectUser } from 'app/slice/user.slice'
import InputTextarea from 'component/Input/InputTextarea'
import * as SendExamUseStyled from 'component/Register/style/styleSendExamination'
import DateInput from 'new-components/inputs/date-input'
import SelectInput from 'new-components/inputs/select-input'
import PageModal from 'new-components/modal/page-modal'
import { useLocation } from 'react-router-dom'
import { getClinicInfo } from 'utils/app.utils'

const CustomTable = styled(Box)<{ type: 'diagnosis' | 'treatments' }>(({ theme, type }) => ({
  '.MuiTableContainer-root': {
    height: '100% !important',
    backgroundColor: colors.transparent,
    '.MuiTable-root': {
      backgroundColor: colors.white,
      '.MuiTableHead-root': {
        '.MuiTableCell-root': {
          '&:first-of-type': {
            button: {
              display: 'none'
            }
          }
        }
      }
    }
  }
}))

type ModalCustomProps = {
  isShow: boolean | false
  setIsShow: (show: boolean) => void
  onClose?: () => void
  patientId: number
  patientCaseId: number
  createdAt: string
  treatments?: any
  diagnosis?: any
  patientRecommendId?: any
  type: 'treatment' | 'historyTreatment' | 'register'
}

export default function MedicalCertificate(props: ModalCustomProps) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  /** SUMMARY TREATMENTS */
  const treatments: TreatmentStateInterface = useSelector(treatment)
  const location = useLocation()

  const user = useSelector(selectUser)

  const [width] = useWindowSize()
  const [tab, setTab] = useState(0)

  const [doctors, setDoctors] = useState<DentistInterface[]>([])
  const [lang, setLang] = useState<any>('th')
  const [isEmpty, setIsEmpty] = useState(false)
  const [summeryTreatments, setSummeryTreatments] = useState([] as any)
  const [isCheckDiagnosis, setIsCheckDiagnosis] = useState<any[]>([] as any)
  const [isCheckAllDiagnosis, setIsCheckAllDiagnosis] = useState('')
  const [isCheckTreatments, setIsCheckTreatments] = useState<any[]>([] as any)
  const [isCheckAllTreatments, setIsCheckAllTreatments] = useState('')
  const [errorDoctorSelect, setErrorDoctorSelect] = useState('')
  const [recommendDoctor, setRecommendDoctor] = useState('')
  const [additionalDx, setAdditionalDx] = useState('')
  const [additionalTreatment, setAdditionalTreatment] = useState('')
  const [isCheckRecommend, setIsCheckRecommend] = useState<any[]>([] as any)
  const [textLength, setTextLength] = useState<number>(0)
  const [additionalDxTextLength, setAdditionalDxTextLength] = useState<number>(0)
  const [additionalTreatmentTextLength, setAdditionalTreatmentTextLength] = useState<number>(0)
  const [errorName, setErrorName] = useState<any>()
  const [errorMaxLength, setErrorMaxLength] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState({ date: '' })
  const [loading, setLoading] = useState(false)
  const branchInfo = getClinicInfo()
  const isDiagnosisSelected = isCheckDiagnosis.length > 0

  /** FILTER */
  const [doctor, setDoctor] = useState<number>(user?.me?.userId || 0)
  const [date, setDate] = useState<string>(moment().format('YYYY-MM-DD'))

  const loadData = useCallback(async () => {
    setLoading(false)
    const doctorsResp = await ClinicApi.findAllDentists()
    const allDoctors: Set<string> = new Set();
    const newTreatments: any[] = [];

    const updateDoctorsAndTreatments = (diagnosis: any[], treatments: any[]) => {
      _.map(diagnosis, (i: any) => {
        if (!allDoctors.has(i.doctorId)) {
          allDoctors.add(i.doctorId);
        }
      });

      _.map(treatments, (i: any) => {
        if (!allDoctors.has(i.doctorId)) {
          allDoctors.add(i.doctorId);
        }
        if (i.tempOrderTreatmentId || i.orderTreatmentId) {
          newTreatments.push(i);
        }
      });

      setSummeryTreatments(newTreatments);
    };

    if (props.type === 'historyTreatment') {
      updateDoctorsAndTreatments(props.diagnosis, props.treatments);
    } else {
      updateDoctorsAndTreatments(treatments.patientDiagnosis, treatments.summeryTreatments);
    }
    setDoctors(_.filter(doctorsResp.data, (i: any) => allDoctors.has(i.dentistId)));

  }, [treatments.summeryTreatments, props.treatments, props.diagnosis])

  useEffect(() => {
    setDate(moment().format('YYYY-MM-DD'))
    loadData()
  }, [loadData, props.isShow, props.patientId, props.patientCaseId, props.createdAt])

  const loadLang = () => {
    if (location.pathname === '/register') {
      setIsEmpty(true)
    }

    if (props.type === 'register') {
      if (branchInfo?.dentistCertificateBlank === '1') {
        setIsEmpty(true)
        return setLang('th')
      } else if (branchInfo?.dentistCertificateBlankEn === '1') {
        setIsEmpty(true)
        return setLang('en');
      }
    } else {
      if (branchInfo?.doctorCertificate === '1') {
        setIsEmpty(false)
        return setLang('th')
      } else if (branchInfo?.dentistCertificateEn === '1') {
        setIsEmpty(false)
        return setLang('en')
      } else if (branchInfo?.dentistCertificateBlank === '1') {
        setIsEmpty(true)
        return setLang('th')
      } else if (branchInfo?.dentistCertificateBlankEn === '1') {
        setIsEmpty(true)
        return setLang('en')
      }
    }
  }

  useEffect(() => {
    loadLang()
  }, [])

  const onCheckAll = (event: any, type: 'Diagnosis' | 'Treatments') => {
    const { checked } = event
    if (type === "Diagnosis") {
      const id = _.map(props.type === 'historyTreatment' ? props.diagnosis : treatments.patientDiagnosis, (i: any) => { return i.patientDiagnosisId })
      if (checked) {
        setIsCheckDiagnosis(Array.from(new Set([...isCheckDiagnosis, ...id])))
        setAdditionalDx('')
        setAdditionalDxTextLength(0)
      }
      else setIsCheckDiagnosis(_.filter(isCheckDiagnosis, (i) => !_.includes(id, i)))

    } else if (type === 'Treatments') {
      const id = _.map(summeryTreatments, (i: any, index: number) => { return props.type === 'historyTreatment' ? i.orderTreatmentId : i.tempOrderTreatmentId })
      if (checked) setIsCheckTreatments(Array.from(new Set([...isCheckTreatments, ...id])))
      else setIsCheckTreatments(_.filter(isCheckTreatments, (i) => !_.includes(id, i)))
    }
  }

  const onCheck = (event: any, type: 'Diagnosis' | 'Treatments') => {
    const { checked, value } = event
    if (type === "Diagnosis") {
      if (checked) {
        setIsCheckDiagnosis([...isCheckDiagnosis, Number(value)])
        setAdditionalDx('')
        setAdditionalDxTextLength(0)
      }
      else setIsCheckDiagnosis(_.filter(isCheckDiagnosis, (i) => { return i !== Number(value) }))
    } else if (type === 'Treatments') {
      if (checked) setIsCheckTreatments([...isCheckTreatments, Number(value)])
      else setIsCheckTreatments(_.filter(isCheckTreatments, (i) => { return i !== Number(value) }))
    }
  }

  const handleAddRecommend = async () => {
    if (props.type === 'historyTreatment') {
      const refItemIdRecomment: string[] = []
      await props?.patientRecommendId?.forEach((item: any) => {
        refItemIdRecomment.push(item.patientRecommendId.toString())
      })
      return refItemIdRecomment.join(',')
    } else {
      const refItemIdVal: string[] = []
      await summeryTreatments?.forEach((item: any) => {
        isCheckTreatments?.forEach((item_2: any) => {
          if (item['tempOrderTreatmentId'] === Number(item_2)) {
            refItemIdVal.push(item.refItemId)
          }
        })
      })
      const refItemIdRecomment: string[] = []
      await treatments?.patientRecommends?.forEach((item: any) => {
        refItemIdVal.forEach((item_2: any) => {
          if (item.refItemId.includes(item_2)) {
            refItemIdRecomment.push(item.patientRecommendId.toString())
          }
        })
      })
      return refItemIdRecomment.join(',')
    }
  }

  const checkSome = (data: any, checkValues: any, idKey: any) => {
    return _.some(data, (i) => _.some(checkValues, (j) => Number(i[idKey]) === Number(j)));
  };

  const checkEvery = (data: any, checkValues: any, idKey: any) => {
    return !_.isEmpty(data) && !_.isEmpty(checkValues) && _.every(data, (i) => _.some(checkValues, (j) => Number(i[idKey]) === Number(j)));
  };

  const statusCheckAllDiagnosis = (checkValues: any, dataAll: any, dataSome: any) => {
    if (!_.isEmpty(checkValues) && !dataAll && dataSome) {
      return 'indeterminate'
    } else {
      return dataAll ? 'checked' : ''
    }
  }


  const handleOnCheckAll = () => {
    const patientDiagnosisData = props.type === 'historyTreatment' ? props.diagnosis : treatments.patientDiagnosis;

    const patientDiagnosisHasSome = checkSome(patientDiagnosisData, isCheckDiagnosis, 'patientDiagnosisId');
    const patientDiagnosisHasAll = checkEvery(patientDiagnosisData, isCheckDiagnosis, 'patientDiagnosisId');


    setIsCheckAllDiagnosis(statusCheckAllDiagnosis(isCheckDiagnosis, patientDiagnosisHasAll, patientDiagnosisHasSome));
    const summeryTreatmentsData = summeryTreatments;

    const summeryTreatmentsHasSome = checkSome(
      summeryTreatmentsData,
      isCheckTreatments,
      props.type === 'historyTreatment' ? 'orderTreatmentId' : 'tempOrderTreatmentId'
    );

    const summeryTreatmentsHasAll = checkEvery(
      summeryTreatmentsData,
      isCheckTreatments,
      props.type === 'historyTreatment' ? 'orderTreatmentId' : 'tempOrderTreatmentId'
    );

    setIsCheckAllTreatments(statusCheckAllDiagnosis(isCheckTreatments, summeryTreatmentsHasAll, summeryTreatmentsHasSome));
  }

  useEffect(() => {
    handleOnCheckAll()
  }, [isCheckDiagnosis, isCheckTreatments, summeryTreatments])

  useEffect(() => {
    if (isDiagnosisSelected && additionalDx) {
      setAdditionalDx('')
      setAdditionalDxTextLength(0)
    }
  }, [isDiagnosisSelected, additionalDx])

  const headCellsDiagnosis = [
    {
      id: 'patientSelect',
      disablePadding: false,
      label: 'CHECKBOX',
      indeterminate: isCheckAllDiagnosis === 'indeterminate',
      checked: isCheckAllDiagnosis === 'checked' && props.type !== 'register',
      disableDropdown: _.isEmpty(isCheckDiagnosis),
      onCheckAll: (event: any) => onCheckAll(event.target, 'Diagnosis'),
      values: [],
      width: '70px'
    },
    { id: 'no', disablePadding: false, label: t('#'), width: '60px' },
    { id: 'branchId', disablePadding: false, label: t('MODAL_MED_CERTIFICATE.TABLE.CODE'), width: '100px' },
    { id: 'cnNumber', disablePadding: false, label: t('MODAL_MED_CERTIFICATE.TABLE.DIAGNOSIS') },
  ]

  const renderDataDiagnosis = (objData: any, no: number) => {
    const { patientDiagnosisId, diagnosisCode, diagnosisName } = objData
    const rowCheck = _.some(isCheckDiagnosis, (i: number) => Number(i) === Number(patientDiagnosisId))

    const objRenderData = {
      key: patientDiagnosisId,
      id: patientDiagnosisId,
      obj: objData,
      rowSelect: rowCheck,
      columns: [
        { option: 'CHECKBOX', align: 'center', label: patientDiagnosisId, disabled: isEmpty || additionalDx.length > 0 },
        { option: 'TEXT', align: 'center', label: no + 1 },
        { option: 'TEXT', align: 'left', label: diagnosisCode },
        { option: 'TEXT', align: 'left', label: diagnosisName },
      ]
    }

    return <TableRowCommon {...objRenderData} onCheck={(event) => onCheck(event.target, 'Diagnosis')} />
  }

  const headCellsTreatments = width >= 768 ? [
    {
      id: 'treatment',
      disablePadding: false,
      label: 'CHECKBOX',
      indeterminate: isCheckAllTreatments === 'indeterminate',
      checked: isCheckAllTreatments === 'checked' && props.type !== 'register',
      disableDropdown: _.isEmpty(isCheckTreatments),
      onCheckAll: (event: any) => onCheckAll(event.target, 'Treatments'),
      values: [],
      width: '70px'
    },
    { id: 'no', disablePadding: false, label: t('#'), width: '60px' },
    { id: 'teeth', disablePadding: false, label: t('MODAL_MED_CERTIFICATE.TABLE.TOOTH'), width: '200px' },
    { id: 'type', disablePadding: false, label: t('MODAL_MED_CERTIFICATE.TABLE.TYPE'), width: '200px' },
    { id: 'name', disablePadding: false, label: t('MODAL_MED_CERTIFICATE.TABLE.SERVICE') },
  ] : [
    {
      id: 'treatment',
      disablePadding: false,
      label: 'CHECKBOX',
      indeterminate: isCheckAllTreatments === 'indeterminate',
      checked: isCheckAllTreatments === 'checked',
      disableDropdown: _.isEmpty(isCheckTreatments),
      onCheckAll: (event: any) => onCheckAll(event.target, 'Treatments'),
      values: [],
      width: '70px'
    },
    { id: 'no', disablePadding: false, label: t('#'), width: '60px' },
    { id: 'free', disablePadding: false, label: '' },
  ]

  const renderDataTreatments = (objData: any, no: number) => {
    const { teeth, operativeTypeName, operativeName, itemTypeName, itemName, tempOrderTreatmentId, orderTreatmentId } = objData
    const rowCheck = _.some(isCheckTreatments, (i: number) => Number(i) === Number(props.type === 'historyTreatment' ? orderTreatmentId : tempOrderTreatmentId))

    const objRenderData = {
      key: props.type === 'historyTreatment' ? orderTreatmentId : tempOrderTreatmentId,
      id: props.type === 'historyTreatment' ? orderTreatmentId : tempOrderTreatmentId,
      obj: objData,
      rowSelect: rowCheck,
      columns: width >= 768 ? [
        { option: 'CHECKBOX', align: 'center', label: props.type === 'historyTreatment' ? orderTreatmentId : tempOrderTreatmentId, disabled: isEmpty },
        { option: 'TEXT', align: 'center', label: no + 1 },
        { option: 'TEXT', align: 'left', label: teeth ? teeth.replaceAll(',', ', ') : '-' },
        { option: 'TEXT', align: 'left', label: operativeTypeName || itemTypeName },
        { option: 'TEXT', align: 'left', label: operativeName || itemName },
      ] : [
        { option: 'CHECKBOX', align: 'center', label: props.type === 'historyTreatment' ? orderTreatmentId : tempOrderTreatmentId, disabled: isEmpty },
        { option: 'TEXT', align: 'center', label: no + 1 },
        {
          option: 'COMPONENT',
          align: 'left',
          component: (
            <>
              <Box className='d-flex mb-1'>
                <Typography sx={{ width: 70, fontWeight: 500, flex: 'none' }}>{t('HISTORY_TREATMENT.MODAL_MEDICAL_CERTIFICATE.TOOTH')}</Typography>
                <Typography>{teeth ? teeth.replaceAll(',', ', ') : '-'}</Typography>
              </Box>
              <Box className='d-flex mb-1'>
                <Typography sx={{ width: 70, fontWeight: 500, flex: 'none' }}>{t('HISTORY_TREATMENT.MODAL_MEDICAL_CERTIFICATE.TYPE')}</Typography>
                <Typography>{operativeTypeName || itemTypeName}</Typography>
              </Box>
              <Box className='d-block'>
                <Typography className='mb-1' sx={{ fontWeight: 500, flex: 'none' }}>{t('HISTORY_TREATMENT.MODAL_MEDICAL_CERTIFICATE.LIST')}</Typography>
                <Typography>{operativeName || itemName}</Typography>
              </Box>
            </>
          )
        },
      ]
    }
    return <TableRowCommon {...objRenderData} onCheck={(event) => onCheck(event.target, 'Treatments')} />
  }
  const componentRef = useRef<HTMLDivElement>(null)
  const BranchInfo = getClinicInfo()

  const onPrint = async () => {

    if (!date && !isEmpty) {
      setErrorMessage({ date: 'กรุณากรอก วันที่ออกใบรับรองแพทย์' })
      return
    }

    if (!doctor) {
      return setErrorDoctorSelect(t('MODAL_MED_CERTIFICATE.NOT_SELECT_DOCTOR'))
    }

    if (isOverLimit) return

    const patientDiagnosisId: any = isCheckDiagnosis.join(',')
    const patientRecommendId: any = await handleAddRecommend() || ''
    const orderTreatmentId: any = props.type === 'historyTreatment' ? isCheckTreatments.join(',') : ''
    const tempOrderTreatmentId: any = props.type === 'treatment' ? isCheckTreatments.join(',') : ''

    setLoading(true)

    if (isEmpty) {
      if (lang === 'th') {
        await onExportMedicalCertificateEmpty()
      } else {
        await onExportMedicalCertificateEnEmpty()
      }
    } else {
      const print = await TreatmentHistoryApi.printMedicalCertificate(props.patientId, props.patientCaseId, {
        date,
        lang,
        doctorId: doctor,
        patientDiagnosisId,
        patientRecommendId,
        orderTreatmentId,
        tempOrderTreatmentId,
        recommendDoctor,
        additionalDx: isDiagnosisSelected ? '' : additionalDx,
        additionalTreatment
      }).finally(() => setLoading(false))

      if (print.status === 200) {
        window.open(`${fileUrl}/${print.data}`, '_blank')
        dispatch(closeModal())
        setIsCheckAllTreatments('')
        setIsCheckTreatments([])
        setIsCheckAllDiagnosis('')
        setIsCheckDiagnosis([])
      }
      setLoading(false)
    }
  }

  const onExportMedicalCertificateEmpty = async () => {
    const print = await TreatmentHistoryApi.printMedicalCertificateEmpty(props.patientId, { lang: 'th' }).finally(() => setLoading(false))
    if (print.status === 200) {
      window.open(`${fileUrl}/${print.data}`, '_blank')
      dispatch(closeModal())
      setIsCheckAllTreatments('')
      setIsCheckTreatments([])
      setIsCheckAllDiagnosis('')
      setIsCheckDiagnosis([])
    }
  }

  const onExportMedicalCertificateEnEmpty = async () => {
    const print = await TreatmentHistoryApi.printMedicalCertificateEmpty(props.patientId, { lang: 'en' }).finally(() => setLoading(false))
    if (print.status === 200) {
      window.open(`${fileUrl}/${print.data}`, '_blank')
      dispatch(closeModal())
      setIsCheckAllTreatments('')
      setIsCheckTreatments([])
      setIsCheckAllDiagnosis('')
      setIsCheckDiagnosis([])
    }
  }

  const handleChangeName = (e: any) => {
    setErrorName('')
    const name = e === '' ? '' : String(e)
    const contentLength = name.length
    setRecommendDoctor(name)
    setTextLength(contentLength)
    setErrorMaxLength(contentLength > 500)
  }

  const handleChangeAdditionalDx = (e: any) => {
    const text = e === '' ? '' : String(e)
    setAdditionalDx(text)
    setAdditionalDxTextLength(text.length)
  }

  const handleChangeAdditionalTreatment = (e: any) => {
    const text = e === '' ? '' : String(e)
    setAdditionalTreatment(text)
    setAdditionalTreatmentTextLength(text.length)
  }

  const buildOverLimitHelper = (length: number, max = 500) => {
    if (length <= max) return ''
    const over = length - max
    return `ข้อความเกิน ${over} ตัวอักษร (สูงสุด ${max} ตัวอักษร)`
  }

  const isOverLimit = textLength > 500 || additionalDxTextLength > 500 || additionalTreatmentTextLength > 500


  const renderDisabledTypePrint = (lang: "th" | "en") => {
    const isLang = lang === "th" ? "" : "En";
    if (props.type === "register") {
      if (lang === "th") {
        if (branchInfo?.dentistCertificateBlank === "0" && branchInfo?.dentistCertificateBlankEn === "0") {
          return true;
        }
        return branchInfo?.dentistCertificateBlank !== "1";
      } else {
        if (branchInfo?.dentistCertificateBlankEn === "1" && branchInfo?.dentistCertificateBlankEn === "1") {
          return false;
        }
        return branchInfo?.dentistCertificateBlankEn !== "1";
      }
    } else {
      if (!isEmpty) {
        if (lang === 'th') {
          return branchInfo?.doctorCertificate !== '1';
        }
        return branchInfo?.[`dentistCertificate${isLang}`] !== '1';
      } else {
        return branchInfo?.[`dentistCertificateBlank${isLang}`] !== '1';
      }
    }
  };


  const handleFormatChange = (type: "doctorCertificate" | "dentistCertificateBlank") => {
    if (props.type === 'register') {
      return type === 'doctorCertificate' ? true : false;
    } else {
      if (type === 'doctorCertificate') {
        if (lang === 'th') {
          return branchInfo?.doctorCertificate !== '1';
        } else {
          return branchInfo?.dentistCertificateEn !== '1';
        }
      } else {
        if (lang === 'th') {
          return branchInfo?.dentistCertificateBlank !== '1';
        } else {
          return branchInfo?.dentistCertificateBlankEn !== '1';
        }
      }
    }
  };


  return (
    <>
      <PageModal
        isOpen
        title={t('MODAL_MED_CERTIFICATE.TITLE')}
        size='M'
        handleClose={() => {
          dispatch(resetModal())
          props.setIsShow(false)
        }}
        onCancel={{
          onClick: () => {
            dispatch(resetModal())
            props.setIsShow(false)
          }
        }}
        onSubmit={{ onClick: onPrint, title: t('BUTTON.PRINT'), disabled: isOverLimit }}
        overflow
      >
        <>
          <Grid container spacing={2} className="pt-2">
            <Grid container item xs={12} className='w-100 d-block' >
              <Grid container item xs={6} className="d-flex align-items-center">
                <Grid item xs={4}>
                  <Typography sx={{ fontWeight: 500 }}>{t('MODAL_MED_CERTIFICATE.LANGUAGE')}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Box display={'flex'} alignItems={'center'}>
                    <InputRadio
                      checked={lang === 'th'}
                      className="radio"
                      onClick={(e: any) => setLang('th')}
                      disabled={renderDisabledTypePrint('th')}
                    />
                    <Typography
                      sx={{
                        color: renderDisabledTypePrint('th') ? colors.disabledGray : 'black',
                      }}
                    >
                      {t('BUTTON.LANGUAGE.TH')}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box display={'flex'} alignItems={'center'}>
                    <InputRadio
                      checked={lang === 'en'}
                      className="radio"
                      onClick={(e: any) => setLang('en')}
                      disabled={renderDisabledTypePrint('en')}
                    />
                    <Typography
                      sx={{
                        color: renderDisabledTypePrint('en') ? colors.disabledGray : 'black',
                      }}
                    >
                      {t('BUTTON.LANGUAGE.ENG')}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Grid container item xs={6} className="d-flex align-items-center">
                <Grid item xs={4}>
                  <Typography sx={{ fontWeight: 500 }}>{t('MODAL_MED_CERTIFICATE.FORMAT')}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Box display={'flex'} alignItems={'center'}>
                    <InputRadio
                      checked={props.type === 'register' ? false : !isEmpty}
                      className="radio"
                      onClick={(e: any) => {
                        if (branchInfo?.doctorCertificate !== '1' || branchInfo?.dentistCertificateEn !== '1') {
                          if (branchInfo?.doctorCertificate === '1') {
                            setLang('th')
                          } else if (branchInfo?.dentistCertificateEn === '1') {
                            setLang('en')
                          }
                        }
                        setIsEmpty(false)
                      }}
                      disabled={handleFormatChange('doctorCertificate')}
                    />
                    <Typography
                      sx={{
                        color: handleFormatChange('doctorCertificate') ? colors.disabledGray : 'black',
                      }}
                    >
                      {t('MODAL_MED_CERTIFICATE.FORMAT_NOTEMPTY')}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box display={'flex'} alignItems={'center'}>
                    <InputRadio
                      checked={props.type === 'register' ? true : isEmpty}
                      className="radio"
                      onClick={(e: any) => {
                        if (branchInfo?.dentistCertificateBlank !== '1' || branchInfo?.dentistCertificateBlankEn !== '1') {
                          if (branchInfo?.dentistCertificateBlank === '1') {
                            setLang('th')
                          } else if (branchInfo?.dentistCertificateBlankEn === '1') {
                            setLang('en')
                          }
                        }
                        setDate('')
                        setErrorMessage({ date: '' })
                        setIsEmpty(true)
                      }}
                      disabled={handleFormatChange('dentistCertificateBlank')}
                    />

                    <Typography
                      sx={{
                        color: handleFormatChange('dentistCertificateBlank') ? colors.disabledGray : 'black',
                      }}
                    >
                      {t('MODAL_MED_CERTIFICATE.FORMAT_EMPTY')}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} className='w-100'>
              <DateInput
                fullWidth
                required
                key={'date'}
                disabled={isEmpty}
                label={t('MODAL_MED_CERTIFICATE.DATE_EXPORT')}
                value={date}
                onChange={(e: any) => {
                  setDate(moment(e).format('YYYY-MM-DD'))
                  setErrorMessage({ date: '' })
                }}
                onClear={() => setDate('')}
                marginBottomErrorText='12px'
                helperText={errorMessage.date || ''}
              />
            </Grid>
            <Grid item xs={6} className='w-100'>
              <SelectInput
                required={props.type !== 'register'}
                label={t('HISTORY_APPOINTMENT.DOCTOR')}
                value={doctor}
                options={
                  _.map(doctors, (doctorData: DentistInterface, i: number) => ({ value: doctorData.dentistId, name: doctorData.dentistFullname }
                  ))
                }
                onChange={(event) => {
                  setDoctor(event.target.value)
                  setErrorDoctorSelect('')
                }}

                helperText={errorDoctorSelect || ''}
                disabled={isEmpty}
              />
            </Grid>
          </Grid>
          <Divider className="mx-0 my-3 my-md-4" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
          {width < 768 && (
            <SendExamUseStyled.FragmentTab className={'d-block d-xl-none mb-2 mb-md-3 mx-3 mx-md-4'}>
              <button className={`${tab === 0 ? 'active' : ''}`} onClick={() => setTab(0)}>
                {t('MODAL_MED_CERTIFICATE.DIAGNOSIS')}
              </button>
              <button className={`${tab === 1 ? 'active' : ''}`} onClick={() => setTab(1)}>
                {t('MODAL_MED_CERTIFICATE.TREATMENT')}
              </button>
            </SendExamUseStyled.FragmentTab>
          )}
          <Box className={`${tab === 0 ? 'd-flex' : 'd-none'} d-md-flex flex-column overflow-hidden h-100`}>
            <Typography className='mb-3 d-none d-md-block' sx={{ fontSize: 18, fontWeight: 500 }}>{t('MODAL_MED_CERTIFICATE.DIAGNOSIS')}</Typography>
            <CustomTable type={'diagnosis'} className={`h-100 overflow-hidden`}>
              <TableCustom
                tableFixedWidth
                hidePagination
                page={1}
                pageLimit={1}
                sortType={''}
                sortBy={''}
                rowCount={0}
                onSort={() => { return }}
                setPageLimit={() => { return }}
                setPage={() => { return }}
                headCells={headCellsDiagnosis}
                rowsData={_.map(props.type === 'historyTreatment' ? props.diagnosis : treatments.patientDiagnosis, (diagnosis, index: number) => {
                  return renderDataDiagnosis(diagnosis, index)
                })}
                disabled={isEmpty || additionalDx.length > 0}
              />
            </CustomTable>
            <Box style={{ marginTop: '20px' }}>
              <Box sx={{ fontWeight: 400, fontSize: '10px', color: additionalDxTextLength > 500 ? colors.statusInactive : '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${additionalDxTextLength}/${500}`}</Box>
              <InputTextarea label={t('MODAL_MED_CERTIFICATE.ADDITIONAL_DX')}
                onchange={(e: any) => handleChangeAdditionalDx(e.target.value)}
                value={additionalDx}
                height={96}
                disabled={isEmpty || isDiagnosisSelected}
                helperText={buildOverLimitHelper(additionalDxTextLength)}
              />
            </Box>
          </Box>
          <Box className={`${tab === 1 ? 'd-flex' : 'd-none'} d-md-flex flex-column overflow-hidden h-100`}>
            <Typography className='mt-md-4 mb-3 d-none d-md-block' sx={{ fontSize: 18, fontWeight: 500 }}>{t('MODAL_MED_CERTIFICATE.TREATMENT')}</Typography>
            <CustomTable type={'treatments'} className={`h-100 overflow-hidden`}>
              <TableCustom
                tableFixedWidth
                hidePagination
                page={1}
                pageLimit={1}
                sortType={''}
                sortBy={''}
                rowCount={0}
                onSort={() => { return }}
                setPageLimit={() => { return }}
                setPage={() => { return }}
                headCells={headCellsTreatments}
                rowsData={_.map(summeryTreatments, (summaryTreatment, index: number) => {
                  return renderDataTreatments(summaryTreatment, index)
                })}
                disabled={isEmpty}
              />
            </CustomTable>
            <Box style={{ marginTop: '20px' }}>
              <Box sx={{ fontWeight: 400, fontSize: '10px', color: additionalTreatmentTextLength > 500 ? colors.statusInactive : '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${additionalTreatmentTextLength}/${500}`}</Box>
              <InputTextarea label={t('MODAL_MED_CERTIFICATE.ADDITIONAL_TREATMENT')}
                onchange={(e: any) => handleChangeAdditionalTreatment(e.target.value)}
                value={additionalTreatment}
                height={96}
                disabled={isEmpty}
                helperText={buildOverLimitHelper(additionalTreatmentTextLength)}
              />
            </Box>
            <Box style={{ marginTop: '20px' }}>
              <Box sx={{ fontWeight: 400, fontSize: '10px', color: textLength > 500 ? colors.statusInactive : '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${textLength}/${500}`}</Box>
              <InputTextarea label={t('MODAL_MED_CERTIFICATE.REMARK_DOCTOR')}
                onchange={(e: any) => handleChangeName(e.target.value)}
                value={recommendDoctor}
                height={96}
                disabled={isEmpty}
                helperText={buildOverLimitHelper(textLength)}
              />
            </Box>
          </Box>
        </>
      </PageModal>
      {/* print-show */}
      {loading && <Loading show={true} type="fullLoading" />}
      <Box
        className="print-show"
        ref={componentRef}
        sx={{
          position: 'absolute',
          top: '0',
          zIndex: 99999,
          width: '297mm',
          height: '420mm',
          backgroundColor: "#fff",
          overflow: "hidden"
        }}
      >
        <Box className={'pdf-body'} sx={{ padding: '20px', height: '100%', width: "100%" }}>
          <Box className={'pdf-title'} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box
              className={'pdf-branch-logo'}
              sx={{
                height: '100px',
                img: {
                  maxHeight: '100%'
                }
              }}>
              <img src={BranchInfo?.branchLogo || ''} alt="" />
            </Box>
            {/*  */}
            <Box className={'pdf-branch-name'} sx={{ fontWeight: "500" }}>
              {BranchInfo?.branchName || ''}
            </Box>
            <Box sx={{ margin: '16px 0', width: '200px', border: '1px solid #E5E5E5' }} />
            <Box className={'pdf-branch-address'}>
              {BranchInfo?.receiptFullAddress || ''}
            </Box>
            <Box className={'pdf-branch-phone'}>
              {BranchInfo?.branchPhone || ''}
            </Box>
            <Box sx={{ margin: '16px 0', width: '100%', border: '1px solid #E5E5E5' }} />
          </Box>

        </Box>
      </Box>
    </>
  )
}
